// THIRD-PARTY LIBRARIES
import { Droppable, Draggable } from "react-beautiful-dnd";
import { ListGroup } from "react-bootstrap";

// ASSETS (SVGs)
import { ReactComponent as TextIcon } from "./assets/fonts.svg";
import { ReactComponent as DateIcon } from "./assets/date.svg";
import { ReactComponent as TimeIcon } from "./assets/clock.svg";
import { ReactComponent as TextareaIcon } from "./assets/card-text.svg";
import { ReactComponent as NumberIcon } from "./assets/numbers.svg";
import { ReactComponent as RadioIcon } from "./assets/circle-check.svg";
import { ReactComponent as CheckboxIcon } from "./assets/square-check.svg";
import { ReactComponent as DropIcon } from "./assets/dropmenu.svg";
import { ReactComponent as DescriptionIcon } from "./assets/chat-text.svg";
import { ReactComponent as ImageIcon } from "./assets/image.svg";
import { ReactComponent as FileIcon } from "./assets/document.svg";
import { ReactComponent as ColorIcon } from "./assets/colors.svg";
import { ReactComponent as PasswordIcon } from "./assets/key.svg";
import { ReactComponent as LinkIcon } from "./assets/link.svg";
import { ReactComponent as EmailIcon } from "./assets/email.svg";
import { ReactComponent as TextTypeIcon } from "./assets/text-type.svg";

export const controls = [
    {
        type: "title",
        label: "Title",
        icon: <TextIcon />,
    },
    {
        type: "description",
        label: "Description",
        icon: <DescriptionIcon />,
    },
    {
        type: "date",
        label: "Date",
        icon: <DateIcon />,
        primitive: true,
    },
    {
        type: "time",
        label: "Time",
        icon: <TimeIcon />,
        primitive: true,
    },
    {
        type: "datetime-local",
        label: "Date time",
        icon: <TimeIcon />,
        primitive: true,
    },
    {
        type: "textarea",
        label: "Textarea",
        icon: <TextareaIcon />,
        primitive: true,
    },
    {
        type: "text",
        label: "Text",
        icon: <TextTypeIcon />,
        primitive: true,
    },
    {
        type: "password",
        label: "Password",
        icon: <PasswordIcon />,
        primitive: true,
    },
    {
        type: "url",
        label: "URL",
        icon: <LinkIcon />,
        primitive: true,
    },
    {
        type: "email",
        label: "Email",
        icon: <EmailIcon />,
        primitive: true,
    },
    {
        type: "color",
        label: "Color",
        icon: <ColorIcon />,
        primitive: true,
    },
    {
        type: "image",
        label: "Image",
        icon: <ImageIcon />,
        primitive: true,
    },
    {
        type: "file",
        label: "File",
        icon: <FileIcon />,
        primitive: true,
    },
    {
        type: "number",
        label: "Number",
        icon: <NumberIcon />,
        primitive: true,
    },
    {
        type: "radio",
        label: "Radio",
        icon: <RadioIcon />,
        primitive: true,
    },
    {
        type: "checkbox",
        label: "Checkbox",
        icon: <CheckboxIcon />,
        primitive: true,
    },
    {
        type: "dropdown",
        label: "Dropdown",
        icon: <DropIcon />,
        primitive: false,
    },
];

function Controls() {
    return (
        <Droppable
            droppableId="controls_droppable"
            type="controls"
            isDropDisabled="true"
            isCombineEnabled="false"
        >
            {(provided) => (
                <ListGroup
                    className="controls"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                >
                    {controls.map((control, index) => (
                        <Draggable
                            key={index}
                            draggableId={control.type}
                            index={index}
                        >
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    className="control"
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                >
                                    {control?.icon}
                                    <span style={{ color: "white" }}>
                                        {control.label}
                                    </span>
                                </div>
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                </ListGroup>
            )}
        </Droppable>
    );
}

export default Controls;
